export const standards_cn = {
  membershipStatus: '会员身份',
  noRisk: '无保障',
  general: '普货会员',
  specialty: '专项会员',
  supplier: '供应商会员',
  chMarket: '中国营销揽货联盟',
  general15: '普货：15万美元',
  general10: '普货：10万美元',
  general5: '普货：5万美元',
  dangerous10: '危险品：10万美元',
  dangerous5: '危险品：5万美元',
  railway10: '铁路货：10万美元',
  railway5: '铁路货：5万美元',
  ecommerce10: '电商货：10万美元',
  ecommerce5: '电商货：5万美元',
  project10: '项目货：10万美元',
  project5: '项目货：5万美元',
}

export const standards_en = {
  membershipStatus: 'Membership Type',
  noRisk: 'No Coverage',
  general: 'General Cargo Members',
  specialty: 'Specialty Members',
  supplier: 'Supplier Members',
  chMarket: 'China Marketing Member',
  general15: 'General Cargo: USD 150,000',
  general10: 'General Cargo: USD 100,000',
  general5: 'General Cargo: USD 50,000',
  dangerous10: 'Dangerous Goods: USD 100,000',
  dangerous5: 'Dangerous Goods: USD 50,000',
  railway10: 'Railway Cargo: USD 100,000',
  railway5: 'Railway Cargo: USD 50,000',
  ecommerce10: 'eCommerce Cargo: USD 100,000',
  ecommerce5: 'eCommerce Cargo: USD 50,000',
  project10: 'Project Cargo: USD 100,000',
  project5: 'Project Cargo: USD 50,000',
}
